// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"MenuCard_Wrapper__2HWAO","Border":"MenuCard_Border__3CH9a","IconWrapper":"MenuCard_IconWrapper__2Wxqe","ButtonContainer":"MenuCard_ButtonContainer__3Kpj_"};